import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dt-mainCard__content-block" }
const _hoisted_2 = {
  key: 0,
  class: "dt-mainCard__content-block-title"
}
const _hoisted_3 = { class: "block-fileDownload margin-bottom-min" }
const _hoisted_4 = { class: "block-fileDownload__wrapper" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.element.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.element.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.items, (files) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  href: item.url,
                  class: "block-fileDownload__view",
                  target: "_blank"
                }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_5)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  href: item.url,
                  class: "block-fileDownload__download",
                  download: ""
                }, null, 8 /* PROPS */, _hoisted_6)
              ])
            ])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}